var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"la-ball-clip-rotate",class:{ large: 'la-2x', black: 'black' }},[_c('div')])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }